import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useNavigate } from 'react-router-dom';

import Button from '@/components/Button';
import { IconChartBar } from '@/components/icon/tabler/IconChartBar';
import { useTranslate } from '@/state/i18n';
import { ScreenRoutes } from '@/types/router';
import { radiusTokens } from '@/theme/themePrimitives';

/** No campaign yet: results start when the Bodyprint puts an approved offer on air. */
const ResultsEmptyState = () => {
  const t = useTranslate('domain.results.components.ResultsEmptyState');
  const navigate = useNavigate();

  return (
    <Paper variant="outlined" sx={{ borderRadius: radiusTokens.xxl }}>
      <Stack alignItems="center" textAlign="center" gap={1.5} sx={{ py: 8, px: 2 }}>
        <IconChartBar color="primary" sx={{ fontSize: 32 }} />
        <Typography variant="subtitle1" fontWeight={600}>
          {t('title')}
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ maxWidth: 460 }}>
          {t('hint')}
        </Typography>
        <Button variant="outlined" onClick={() => navigate(ScreenRoutes.OFFERS)}>
          {t('offers')}
        </Button>
      </Stack>
    </Paper>
  );
};

export default ResultsEmptyState;
